export default __webpack_public_path__ + "static/media/OTHER_PARTY_FUN.da0b85d2.svg";